import { NormalText } from 'ui/Text';
import styled from'styled-components';

const Description = styled(NormalText)`
  margin: 16px 0;
`;

export default Description;
